<ng-container *transloco="let t">
    <ion-datetime
        hourCycle="h23"
        presentation="time"
        [min]="min$ | async"
        [hourValues]="hourValues$ | async"
        [minuteValues]="minuteValues$ | async"
        [formControl]="timeCtrl"
    ></ion-datetime>

    <div class="flex items-center justify-end">
        <button tuiButton appearance="primary" size="m" (click)="handleSubmit()" [disabled]="timeCtrl.invalid">
            {{ t('accept') }}
        </button>
    </div>
</ng-container>
